<template>
  <div>

    <b-alert variant="danger" v-if="Object.keys(errors).length > 0" show>
      {{ errors }}
    </b-alert>

    <b-container>
      <section class="d-inline-block text-left mx-auto">
        <b-row>
          <b-col>
            <h1>{{ $t('pages.contacts') }}</h1>
            <p><strong>{{ $t('footer.email') }}:</strong> <a href="mailto:peteris@kelle.ventures">peteris@kelle.ventures</a></p>
            <p><strong>{{ $t('footer.phone') }}:</strong> +371 261 260 86</p>
            <p>
              <a href="https://www.facebook.com/finefitofficial" target="_blank" :title="$t('footer.follow.facebook')"><img src="https://finefit.s3.eu-north-1.amazonaws.com/images/social_facebook.svg" width="24" /></a>
              <a href="https://www.instagram.com/finefitofficial" target="_blank" :title="$t('footer.follow.instagram')"><img src="https://finefit.s3.eu-north-1.amazonaws.com/images/social_instagram.svg" width="24" /></a>
              <a href="https://www.linkedin.com/company/finefit" target="_blank" :title="$t('footer.follow.linkedin')"><img src="https://finefit.s3.eu-north-1.amazonaws.com/images/social_linkedin.svg" width="24" /></a>
              <a href="https://twitter.com/finefitofficial" target="_blank" :title="$t('footer.follow.twitter')"><img src="https://finefit.s3.eu-north-1.amazonaws.com/images/social_twitter.svg" width="24" /></a>
            </p>
          </b-col>
        </b-row>
      </section>
    </b-container>

  </div>
</template>

<script>
  export default {
    name: 'Home',
    components: {

    },
    data () {
      return {
        errors: {}
      }
    },
    methods: {

    },
    computed: {

    },
    mounted () {
      // this.$el.addEventListener('click', this.onClose)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
</style>
